module.exports = __webpack_public_path__ + "img/ss.287333f4.svg";